import type React from 'react';
import { cn } from '@/lib/utils';

type BranchStatus = 'APPROVED' | 'PENDING' | 'REJECTED' | 'BLOCKED';

const statusConfig: Record<BranchStatus, { label: string; classes: string }> = {
  APPROVED: { label: 'Одобрен', classes: 'bg-emerald-100 text-emerald-700' },
  PENDING: { label: 'На модерации', classes: 'bg-amber-100 text-amber-700' },
  REJECTED: { label: 'Отклонён', classes: 'bg-red-100 text-red-700' },
  BLOCKED: { label: 'Заблокирован', classes: 'bg-gray-100 text-gray-600' },
};

interface BranchStatusBadgeProps {
  status: string;
  className?: string;
  size?: 'sm' | 'md';
}

const BranchStatusBadge: React.FC<BranchStatusBadgeProps> = ({ status, className, size = 'sm' }) => {
  const config = statusConfig[status as BranchStatus] ?? {
    label: status,
    classes: 'bg-gray-100 text-gray-600',
  };

  const sizeClasses = {
    sm: 'px-2.5 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full font-medium',
        config.classes,
        sizeClasses[size],
        className,
      )}
    >
      {config.label}
    </span>
  );
};

export default BranchStatusBadge;
